import React, {useState, useContext, useEffect} from "react";
import {Link, useHistory, Redirect} from "react-router-dom"
import { UserContext } from "../../App";
import {authenticate, isAuthenticated, setTheme} from "./helper"
import AppTheme from "../colors";

const Login = () => {
    const theme = JSON.parse(localStorage.getItem("theme"));
    const currentTheme = AppTheme["light"]
    const history = useHistory()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState(false)
    const [processing, setProcessing] = useState(false)
    useEffect(() => {
            setTheme()
    }, [])
    const PostData = (e) => {
        e.preventDefault();
        setProcessing(true)
        fetch(`${process.env.REACT_APP_BACKEND}/signin`, {
            method:"POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                password
            })
        })
        .then(res => res.json())
        .then(data => {
            if(data.error){
                setError(data.error);
                setProcessing(false);
            }
            else{
                authenticate(data, () => {
                    console.log(data);
                    setError(false);
                    setProcessing(false)
                })
                
                history.push("/")
                window.location.reload()
                // return <Redirect to="/"/>
                
            }
        })
        .catch(err => console.log(err))

    }
    
    const errorMessege = () => (
        <div className="row">
            <div className="col s12 center-align">
                <div className="card-panel red white-text" style={{display: error ? "" : "none"}}>
                    {error}
                </div>
            </div>
        </div>
    )

    

    return (
        <>
        {theme ? (
            <div className="row" >
            <div className="col s12">
                <div className="mycard">
            
                    <div className="card auth-card input-field" style={{backgroundColor: `${currentTheme.navColor}`, color: `${currentTheme.textColor}`}}>
                    {errorMessege()}
                        <h2 style={{color: `${currentTheme.textColor}`}}>SocioRoorkee</h2>
                        <input type="text" placeholder="email" value={email} onChange={(e) => setEmail(e.target.value)} style={{color: `${currentTheme.textColor}`}}/>
                        <input type="password" placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{color: `${currentTheme.textColor}`}}/>
                        <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={PostData}>
                            {processing ? 'Logging In...' : 'Login'}
                        </button>
                        <h6><Link to="/signup" className="blue-text ">Don't have an account !</Link></h6>
                        <h6><Link to="/reset" className="blue-text ">Forget Password</Link></h6>
                    </div>
                    
                </div>
            </div>
        </div>
        ) : (
            <div className="row">
            <div className="col s12">
                <div className="mycard">
            
                    <div className="card auth-card input-field">
                    {errorMessege()}
                        <h2>SocioRoorkee</h2>
                        <input type="text" placeholder="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        <input type="password" placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={PostData}>
                            {processing ? 'Logging In...' : 'Login'}
                        </button>
                        <h6><Link to="/signup" className="blue-text text-darken-4">Don't have an account !</Link></h6>
                        <h6><Link to="/reset" className="blue-text text-darken-4">Forget Password</Link></h6>
                    </div>
                    
                </div>
            </div>
        </div>
        ) }
        
       </>
    )
}

export default Login;